import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import createWebStorage from "redux-persist/lib/storage/createWebStorage";
import { combineReducers } from "@reduxjs/toolkit";
import ModalReducer from "../ReduxSlices/ModalSlice";
import AuthReducer from "../ReduxSlices/AuthSlice";
import NFTReducer from "../ReduxSlices/NFTSlice";
import CommunicationReducer from "../ReduxSlices/CommunicationSlice";
import TimeReducer from "../ReduxSlices/TimeSlice";
import ReservationReducer from "../ReduxSlices/ReservationSlice";
import NotificationReducer from "../ReduxSlices/NotificationSlice";
import SearchReducer from "../ReduxSlices/SearchSlice";
import YieldReducer from "../ReduxSlices/PropertySlice";
import RentalPropertyReducer from "../ReduxSlices/RentalPropertySlice";
import PerpsReducer from "../ReduxSlices/PerpSlice";
import LiquidationReducer from "../ReduxSlices/LiquidationSlice";
import TradeReducer from "../ReduxSlices/TradeSlice";
import MintReducer from "../ReduxSlices/MintSlice";

// Create sessionStorage for tab-specific persistence
const createNoopStorage = () => {
  return {
    getItem(_key) {
      return Promise.resolve(null);
    },
    setItem(_key, value) {
      return Promise.resolve(value);
    },
    removeItem(_key) {
      return Promise.resolve();
    },
  };
};

const sessionStorage = typeof window !== "undefined" ? createWebStorage("session") : createNoopStorage();

// Persist configuration for auth state - using sessionStorage for tab-specific persistence
const authPersistConfig = {
  key: 'auth',
  storage: sessionStorage, // Use sessionStorage instead of localStorage
  whitelist: ['account', 'wallet', 'isConnected'], // Only persist these fields
};

// Persist configuration for other states that should persist
const persistConfig = {
  key: 'root',
  storage: sessionStorage, // Use sessionStorage instead of localStorage
  whitelist: ['auth'], // Only persist auth state
};

const rootReducer = combineReducers({
  modal: ModalReducer,
  auth: persistReducer(authPersistConfig, AuthReducer),
  nft: NFTReducer,
  communication: CommunicationReducer,
  time: TimeReducer,
  reservation: ReservationReducer,
  notification: NotificationReducer,
  search: SearchReducer,
  yield: YieldReducer,
  rentalProperties: RentalPropertyReducer,
  perps: PerpsReducer,
  liquidation: LiquidationReducer,
  trade: TradeReducer,
  mint: MintReducer,
});

export const Store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(Store);